<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>InspirationFotoDES:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-6">
          <app-block-text
            [maxLength]="4000"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'EventImageDesktop')"
            [blockData]="block.variables?.EventImageDesktop ?? ''"
            [placeholder]="imageDesktopPlaceholder"
            variable="EventImageDesktop"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'EventImageMobile')"
            [blockData]="block.variables?.EventImageMobile ?? ''"
            [placeholder]="imageMobilePlaceholder"
            variable="EventImageMobile"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-12">
          <app-block-text
            [maxLength]="4000"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'EventImageHref')"
            [blockData]="block.variables?.EventImageHref ?? ''"
            [placeholder]="imageHrefPlaceholder"
            variable="EventImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'EventImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.EventImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'alt'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'EventImageAlt')"
            [blockData]="block.variables?.EventImageAlt ?? ''"
            [placeholder]="imageAltPlaceholder"
            variable="EventImageAlt"
          ></app-block-text>
        </div>

        <div class="col-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'EventText')"
            [blockData]="block.variables?.EventText ?? ''"
            [placeholder]="textPlaceholder"
            variable="EventText"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'EventCtaLink')"
            [blockData]="block.variables?.EventCtaLink ?? ''"
            [placeholder]="ctaLinkPlaceholder"
            variable="EventCtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'EventCtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.EventCtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="30"
            (handleOnChange)="onChange($event, 'EventCtaText')"
            [blockData]="block.variables?.EventCtaText ?? ''"
            [placeholder]="ctaTextPlaceholder"
            variable="EventCtaText"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-left">
          <div class="col-12" *ngIf="block.variables?.EventImageDesktop">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.EventImageHref))"
            >
              <img
                [src]="$safeNavigationMigration(block.variables?.EventImageDesktop)"
                class="img-fluid full-width-img"
                [alt]="$safeNavigationMigration(block.variables?.EventImageAlt)"
              />
            </a>
          </div>
        </div>
        <div class="row text-center">
          <div class="col-12">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.EventText)"></p>
          </div>
          <div class="col-12 mt-2" *ngIf="block.variables?.EventCtaLink">
            <a
              class="btn btn-primary"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.EventCtaLink))"
              target="_blank"
              [innerHTML]="$safeNavigationMigration(block.variables?.EventCtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
